<template>
  <div v-if="descricao" :class="['descricao-container', { 'padding-bottom': paddingBottom }]">
    <label :class="{ 'resumo-label': tipo == 'resumo' }" v-if="titulo">{{ titulo }}</label>
    <p v-if="this.porcentagem">{{ valor }}</p>
    <p :class="{ 'resumo-descricao': tipo == 'resumo' }" v-else>{{ descricao }}</p>
  </div>
</template>

<script>
export default {
  name: "Descricao",

  props: {
    paddingBottom: Boolean,
    titulo: String,
    descricao: String,
    porcentagem: Number,
    tipo: String
  },

  data() {
    return {};
  },

  mounted() {},

  computed: {
    valor() {
      if (this.porcentagem) {
        return (
          parseFloat(this.descricao)
            .toFixed(this.porcentagem)
            .toString()
            .replace(".", ",") + "%"
        );
      }
      return;
    }
  },

  methods: {}
};
</script>

<style lang="scss" scoped>
.descricao-container {
  label {
    font-size: 1rem;
    font-weight: 600;
  }
  .resumo-descricao {
    font-size: 13px;
    margin-bottom: 4px;
    white-space: nowrap;
  }
  .resumo-label {
    font-size: 13px;
    margin-bottom: 0px;
    margin-top: 4px;
  }
  p {
    text-align: justify;
    margin: 0;
  }
}
.padding-bottom {
  margin-bottom: 0.8rem;
}
</style>
